import type { FC } from "react"

async function participantCoachingSessionsPagePreloader(): Promise<void> {
    await import("./participant.coaching-sessions.page").then(
        ({ ParticipantCoachingSessionsPage: S }): { default: FC } => ({
            default: S
        })
    )
}

export { participantCoachingSessionsPagePreloader }
